// extracted by mini-css-extract-plugin
export default {"option":"MobileMenu_option__TORYd","selectedOption":"MobileMenu_selectedOption__BKjgz"};